// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__0BPWF","footerExtraMargin":"Footer_footerExtraMargin__Gf6sA"};